export function Logo({ size = "md", inverted = false, stacked = false, className = "" }) {
  const sizes = {
    sm: "text-xl",
    md: "text-2xl md:text-3xl",
    lg: "text-4xl md:text-5xl",
  };
  const stackedSizes = {
    sm: "text-base",
    md: "text-lg md:text-xl",
    lg: "text-3xl md:text-5xl",
  };
  const color = inverted ? "text-[#FAF8F3]" : "text-[#4A7A3D]";

  if (stacked) {
    return (
      <span
        data-testid="logo-mark"
        className={`font-display leading-[1.05] tracking-tight ${stackedSizes[size]} ${color} ${className} flex flex-col`}
        style={{ letterSpacing: "0" }}
      >
        <span>RWANA</span>
        <span>BIZIN</span>
        <span>LEGA</span>
      </span>
    );
  }
  return (
    <span
      data-testid="logo-mark"
      className={`font-display leading-none ${sizes[size]} ${color} ${className}`}
      style={{ letterSpacing: "0.02em" }}
    >
      RWANA<span className="opacity-90"> BIZIN</span> LEGA
    </span>
  );
}
